<template>
  <CardSection :loading="isSavableStateLoading" :error="majorError">
    <template #header>
      Mask CSV Zips
    </template>
    <template #body>
      <div class="form-group row">
        <div class="form-group mr-2 mb-0 col-12 d-flex">
          <router-link :to="{ name: 'admin_unos_mask_csv_new' }"
            class="btn btn-primary btn-sm ml-auto">
            Mask new zip
          </router-link>
        </div>
      </div>
      <PortalTable
        table-id="mask_csv_zips"
        ref="mask_csv_zips_index"
        :table-data="records"
        :total-records="pagination.totalRecords"
        :page="pagination.pageNumber"
        :page-count="pagination.pageCount"
        :loading="isSavableStateProcessing"
        :filter-values="filterValues"
        :add-filter-to-route="true"
        filter-display="row"
        empty="No Zip files uploaded yet."
        @on-page="onPageChange"
        @on-sort="onSortChange"
        @on-filter-change="onFilterChange">
        <template #columns>
          <Column field="details.stored_zip_file.stored_file.original_filename" header="File" :show-filter-menu="false"/>
          <Column field="created_at.display" header="Uploaded At" :show-filter-menu="false"/>
          <Column field="uploaded_by.full_name" header="Uploaded By" :show-filter-menu="false"/>
          <Column field="updated_at.display" header="Updated At" :show-filter-menu="false"/>
          <Column header="Status" :show-filter-menu="false">
            <template #body="slotProps">
              <span class="status-badge" :class="slotProps.data.statusBadgeClass">
                {{ slotProps.data.statusDisplayText }}
              </span>
            </template>
          </Column>
          <Column header="Actions">
            <template #body="slotProps">
              <RouterLink :to="{ name: 'admin_unos_mask_csv_show', params: { id: slotProps.data.id }}">Edit</RouterLink>
            </template>
          </Column>
        </template>
      </PortalTable>
    </template>
  </CardSection>
</template>
<script setup lang="ts">
import CardSection from "@/src/components/shared/CardSection.vue";
import { usePagination } from "@/src/composables/usePagination";
import { useSavableState } from '@/src/composables/useSavableState';
import { MaskCSVZip } from '@/src/models/unos/mask-csv-zip';
import { APIPagyResponse } from "@/src/types";
// @ts-ignore
import PortalTable from "@/src/components/shared/PortalTable.vue";
import Column from 'primevue/column';

type ListResponse = APIPagyResponse<MaskCSVZip>;
const { 
  majorError, 
  isSavableStateLoading,
  isSavableStateProcessing,
  processAsync
} = useSavableState();

const getMaskCSVZips = async () => {
  // toAPIPayload is a ComputedRef; must unwrap with .value or axios sees the ref object
  // instead of { page, sort_by, sort_type } and page stays at 1.
  return await processAsync<ListResponse>((): Promise<ListResponse> => MaskCSVZip.search(toAPIPayload.value))
};

const filterValues = {};

const {
  toAPIPayload,
  records,
  pagination,
  onPageChange,
  onSortChange,
  onFilterChange
} = usePagination<MaskCSVZip>({
  getRowData: getMaskCSVZips,
  filterValues: filterValues
});
</script>

<style scoped>
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.2;
  border-radius: 0.25rem;
  text-align: center;
  white-space: nowrap;
  text-transform: uppercase;
}
</style>